<!-- Business Navbar -->
<bc-business-navbar
  [serviceProviderId]="serviceProviderId"
  [partnerId]="$safeNavigationMigration((atlasIdentifier$ | async)?.partnerId)"
  [accountId]="$safeNavigationMigration((atlasIdentifier$ | async)?.accountId)"
  [hideNotifications]="false"
  [hideCenters]="false"
  [defaultURL]="WSPdefaultURL"
  entitlementId="partner-access"
></bc-business-navbar>
